import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useActivityVacancies } from "PFCore/hooks/queries/activity";
import { useTranslation } from "react-i18next";

export const ActivityVacancies = () => {
  const { activityId } = useActivityShowContext();

  const { t } = useTranslation("activities", { keyPrefix: "show.details.vacancies" });

  const { data: vacancies } = useActivityVacancies({
    activityId,
    perPage: 0
  });

  return (
    <Inline data-qa-id="ActivityVacancies" spread alignItems="center">
      <Typography variant="bodyBold">{t("title")}</Typography>
      <Typography variant="bodyRegular">
        {t("details", {
          open: vacancies?.meta.totalOpened,
          total: vacancies?.meta.total
        })}
      </Typography>
    </Inline>
  );
};
